import React from 'react';
import css from './Placeholder.APP_TARGET.scss';
import { css as uiCss } from 'panamera-react-ui';
import classNames from 'classnames';

const { grid } = uiCss;

export const Placeholder = () => {
    return (
        <div className={ `${ css.placeholder } ${grid.row}` } data-aut-id="placeholder">
            <div className={ `${grid.col} ${grid.xl8} ${grid.l12} ${grid.m12} ${grid.s12} ${ css.column }` }>
                <div className={ classNames(css.card, css.cardContent) }>
                    <div className={ `${ css.bigPhoto } ${ css.animatedBackground }` } />
                    <div className={ css.gallery } >
                        <div className={ `${ css.photo } ${ css.animatedBackground }` } />
                        <div className={ `${ css.photo } ${ css.animatedBackground }` } />
                        <div className={ `${ css.photo } ${ css.animatedBackground }` } />
                        <div className={ `${ css.photo } ${ css.animatedBackground }` } />
                        <div className={ `${ css.photo } ${ css.animatedBackground }` } />
                        <div className={ `${ css.photo } ${ css.animatedBackground }` } />
                        <div className={ `${ css.photo } ${ css.animatedBackground }` } />
                        <div className={ `${ css.photo } ${ css.animatedBackground }` } />
                    </div>
                </div>
                <div className={ classNames(css.card, css.cardContent) }>
                    <div className={ `${ css.subTitle } ${ css.animatedBackground }` } />
                    <div className={ `${ css.text } ${ css.animatedBackground }` } />
                </div>
            </div>
            <div className={ `${ css.column } ${grid.col} ${grid.xl4} ${grid.l12} ${grid.m12} ${grid.s12}` }>
                <div className={ classNames(css.card, css.cardContent) }>
                    <div className={ `${ css.title } ${ css.animatedBackground }` } />
                    <div className={ `${ css.subTitle } ${ css.animatedBackground }` } />
                </div>
                <div className={ classNames(css.card, css.cardContent) }>
                    <div className={ `${ css.subTitle } ${ css.animatedBackground }` } />
                    <div className={ css.user } >
                        <div className={ `${ css.avatar } ${ css.animatedBackground }` } />
                        <div className={ `${ css.text } ${ css.animatedBackground }` } />
                    </div>
                </div>
                <div className={ classNames(css.card, css.cardContent) }>
                    <div className={ `${ css.subTitle } ${ css.animatedBackground }` } />
                    <div className={ `${ css.text } ${ css.animatedBackground }` } />
                    <div className={ `${ css.map } ${ css.animatedBackground }` } />
                </div>
                <div className={ classNames(css.card, css.cardContent) }>
                    <div className={ `${ css.subTitle } ${ css.animatedBackground }` } />
                    <div className={ `${ css.text } ${ css.animatedBackground }` } />
                </div>
            </div>
        </div>
    );
};

export default Placeholder;
